import { render, staticRenderFns } from "./BaseInputForm.vue?vue&type=template&id=e1ea4cd8&"
import script from "./BaseInputForm.vue?vue&type=script&lang=js&"
export * from "./BaseInputForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports